module.exports = __webpack_public_path__ + "assets/img/news (29).25184f13.png";